__turbopack_context__.v({
  "accordionSlideOverwrite": "horizontal-event-card-skeleton-module-scss-module__7X5gHG__accordionSlideOverwrite",
  "container": "horizontal-event-card-skeleton-module-scss-module__7X5gHG__container",
  "fadeIn": "horizontal-event-card-skeleton-module-scss-module__7X5gHG__fadeIn",
  "fadeOut": "horizontal-event-card-skeleton-module-scss-module__7X5gHG__fadeOut",
  "imageBlock": "horizontal-event-card-skeleton-module-scss-module__7X5gHG__imageBlock",
  "metaBlockNarrow": "horizontal-event-card-skeleton-module-scss-module__7X5gHG__metaBlockNarrow",
  "metaBlockWide": "horizontal-event-card-skeleton-module-scss-module__7X5gHG__metaBlockWide",
  "scaleIn": "horizontal-event-card-skeleton-module-scss-module__7X5gHG__scaleIn",
  "scaleOut": "horizontal-event-card-skeleton-module-scss-module__7X5gHG__scaleOut",
  "titleBlock": "horizontal-event-card-skeleton-module-scss-module__7X5gHG__titleBlock",
  "zoomIn": "horizontal-event-card-skeleton-module-scss-module__7X5gHG__zoomIn",
  "zoomOut": "horizontal-event-card-skeleton-module-scss-module__7X5gHG__zoomOut",
});
